import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[AlphabetsOnly]',
})
export class AlphabetsOnlyDirective {
  regex: RegExp = /^[a-zA-Z\s]+$/;

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    const enteredKey = event.key;
    if (!this.regex.test(enteredKey)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    const pastedText = event.clipboardData.getData('text/plain');
    if (!this.regex.test(pastedText)) {
      event.preventDefault();
    }
  }
}